module.exports = __webpack_public_path__ + "static/img/zczs.cb19cf53.jpg";